export interface CityPageData {
  mapBbox: string;   // "lon_min,lat_min,lon_max,lat_max"
  mapMarker: string; // "lat,lon"
  mapCaption: string;
  areas: string[];
  nearbyMunicipalities: string[];
  stats: Array<{ value: string; label: string }>;
  descriptionPara1: string;
  descriptionPara2: string;
}

const DEFAULT_DATA: CityPageData = {
  mapBbox: "14.12,49.00,24.20,54.84",
  mapMarker: "52.0,19.0",
  mapCaption: "Obsługujemy całe miasto i okolice",
  areas: [
    "Śródmieście",
    "Dzielnice północne",
    "Dzielnice południowe",
    "Dzielnice wschodnie",
    "Dzielnice zachodnie",
    "Nowe osiedla",
    "Starsza zabudowa",
    "Strefa podmiejska",
  ],
  nearbyMunicipalities: [],
  stats: [
    { value: "3", label: "typy przeglądów na platformie" },
    { value: "7 dni", label: "średni czas realizacji wizyty" },
    { value: "online", label: "porównanie firm i cen" },
    { value: "protokół", label: "dokumentacja po przeglądzie" },
  ],
  descriptionPara1:
    "Regularne kontrole instalacji elektrycznych, gazowych oraz czujników dymu to klucz do bezpieczeństwa mieszkańców i nieruchomości. W praktyce najwięcej usterek dotyczy starszej zabudowy oraz lokali po modernizacjach wykonanych bez pełnej dokumentacji.",
  descriptionPara2:
    "Przeglądy realizowane za pośrednictwem platformy obejmują komplet protokołów i dokumentów wymaganych przy kontroli okresowej zgodnie z art. 62 Prawa budowlanego.",
};

export const CITY_PAGE_DATA: Record<string, CityPageData> = {
  krakow: {
    mapBbox: "19.7943,49.9667,20.0872,50.1236",
    mapMarker: "50.0614,19.9366",
    mapCaption: "Obsługujemy wszystkie 18 dzielnic Krakowa oraz gminy ościenne",
    areas: [
      "Stare Miasto",
      "Grzegórzki",
      "Prądnik Czerwony",
      "Prądnik Biały",
      "Krowodrza",
      "Bronowice",
      "Zwierzyniec",
      "Dębniki",
      "Łagiewniki–Borek Fałęcki",
      "Swoszowice",
      "Podgórze Duchackie",
      "Bieżanów–Prokocim",
      "Podgórze",
      "Czyżyny",
      "Mistrzejowice",
      "Bieńczyce",
      "Wzgórza Krzesławickie",
      "Nowa Huta",
    ],
    nearbyMunicipalities: [
      "Wieliczka",
      "Niepołomice",
      "Skawina",
      "Myślenice",
      "Zielonki",
      "Wielka Wieś",
    ],
    stats: [
      { value: "~380 000", label: "mieszkań i lokali w mieście" },
      { value: "18", label: "dzielnic objętych obsługą" },
      { value: "35%", label: "budynków sprzed 1970 roku" },
      { value: "kamienica + blok PRL", label: "dominujące typy zabudowy" },
    ],
    descriptionPara1:
      "Kraków to miasto o wyjątkowo zróżnicowanej strukturze mieszkaniowej. Zabytkowe kamienice Kazimierza, Starego Miasta i Podgórza sąsiadują z blokowiskami z lat 60–80. ubiegłego wieku oraz dynamicznie rozwijającymi się nowymi osiedlami na Ruczaju, w Bieżanowie czy Mistrzejowicach.",
    descriptionPara2:
      "Starsza substancja budowlana – szacowana na ponad 35% budynków sprzed 1970 roku – niesie ze sobą podwyższone ryzyko awarii instalacji elektrycznych i gazowych. Aluminiowe przewody, przestarzałe tablice bezpiecznikowe czy nieszczelne instalacje gazowe to typowe usterki w kamienicach i budynkach z wielkiej płyty.",
  },

  warszawa: {
    mapBbox: "20.8517,52.0978,21.2711,52.3679",
    mapMarker: "52.2297,21.0122",
    mapCaption: "Obsługujemy wszystkie 18 dzielnic Warszawy i gminy ościenne",
    areas: [
      "Śródmieście",
      "Mokotów",
      "Praga-Południe",
      "Praga-Północ",
      "Żoliborz",
      "Ursynów",
      "Wola",
      "Białołęka",
      "Wilanów",
      "Bielany",
      "Bemowo",
      "Ochota",
      "Targówek",
      "Ursus",
      "Włochy",
      "Wawer",
      "Rembertów",
      "Wesoła",
    ],
    nearbyMunicipalities: [
      "Piaseczno",
      "Legionowo",
      "Pruszków",
      "Wołomin",
      "Marki",
      "Łomianki",
    ],
    stats: [
      { value: "~800 000", label: "mieszkań i lokali w mieście" },
      { value: "18", label: "dzielnic objętych obsługą" },
      { value: "45%", label: "budynków sprzed 1990 roku" },
      { value: "bloki wielka płyta", label: "dominujący typ zabudowy" },
    ],
    descriptionPara1:
      "Warszawa to największe miasto Polski z wyjątkowo zróżnicowaną strukturą zabudowy. Historyczne kamienice Śródmieścia, Pragi i Żoliborza sąsiadują z blokowiskami z okresu PRL oraz nowoczesnymi inwestycjami deweloperskimi. Prawie połowa stołecznych budynków mieszkalnych pochodzi sprzed 1990 roku, co oznacza, że instalacje elektryczne i gazowe w wielu z nich nie były modernizowane od kilkudziesięciu lat.",
    descriptionPara2:
      "Właściciele mieszkań i zarządcy nieruchomości w Warszawie muszą szczególnie dbać o terminowe przeglądy. W przypadku starszej zabudowy typowe usterki to aluminiowe lub papierowe przewody elektryczne, zestarzałe tablice bezpiecznikowe oraz przestarzałe instalacje gazowe wymagające wymiany rur lub uszczelnień.",
  },

  wroclaw: {
    mapBbox: "16.8024,51.0366,17.1762,51.2145",
    mapMarker: "51.1079,17.0385",
    mapCaption: "Obsługujemy wszystkie 5 dzielnic Wrocławia i okolice",
    areas: [
      "Stare Miasto",
      "Śródmieście",
      "Krzyki",
      "Fabryczna",
      "Psie Pole",
      "Nowy Dwór",
      "Brochów",
      "Jagodno",
      "Ołtaszyn",
      "Klecina",
      "Grabiszyn",
      "Karłowice",
      "Biskupin",
      "Sępolno",
      "Zalesie",
    ],
    nearbyMunicipalities: [
      "Długołęka",
      "Kobierzyce",
      "Siechnice",
      "Oława",
      "Oleśnica",
    ],
    stats: [
      { value: "~300 000", label: "mieszkań i lokali w mieście" },
      { value: "5", label: "dzielnic objętych obsługą" },
      { value: "40%", label: "budynków sprzed 1980 roku" },
      { value: "kamienice przedwojenne", label: "dominujący typ centrum" },
    ],
    descriptionPara1:
      "Wrocław to dynamicznie rozwijające się miasto z unikalną historią architektoniczną. Duża część zabudowy pochodzi z okresu sprzed 1945 roku i wymaga szczególnej uwagi w zakresie stanu technicznego instalacji. Obok historycznych kamienic i secesyjnych willi, w mieście dominują bloki z lat 60–80. oraz nowe osiedla na obrzeżach.",
    descriptionPara2:
      "Właściciele nieruchomości we Wrocławiu powinni zwrócić szczególną uwagę na stan instalacji elektrycznej – wiele budynków sprzed 1970 roku wciąż posiada instalacje aluminiowe, które są uznawane za niebezpieczne i wymagają wymiany przez uprawnionego elektryka.",
  },

  poznan: {
    mapBbox: "16.7388,52.3124,17.0682,52.5145",
    mapMarker: "52.4064,16.9252",
    mapCaption: "Obsługujemy wszystkie 5 dzielnic Poznania i okolice",
    areas: [
      "Stare Miasto",
      "Nowe Miasto",
      "Grunwald",
      "Wilda",
      "Jeżyce",
      "Winogrady",
      "Naramowice",
      "Piątkowo",
      "Dębiec",
      "Górczyn",
      "Rataje",
      "Chartowo",
      "Ławica",
      "Junikowo",
      "Fabianowo",
    ],
    nearbyMunicipalities: [
      "Swarzędz",
      "Luboń",
      "Czerwonak",
      "Mosina",
      "Murowana Goślina",
    ],
    stats: [
      { value: "~270 000", label: "mieszkań i lokali w mieście" },
      { value: "5", label: "dzielnic objętych obsługą" },
      { value: "38%", label: "budynków sprzed 1980 roku" },
      { value: "kamienice Jeżyc", label: "historyczny typ centrum" },
    ],
    descriptionPara1:
      "Poznań łączy XIX-wieczną zabudowę śródmiejską z rozległymi osiedlami bloków z wielkiej płyty i nowoczesnymi dzielnicami willowymi. Stare Miasto i okolice Jeżyc to kamienice wymagające regularnych kontroli instalacji, natomiast Piątkowo i Rataje to głównie zabudowa z lat 70–80. ubiegłego wieku.",
    descriptionPara2:
      "W Poznaniu szczególnie problematyczne są instalacje gazowe w budynkach wielorodzinnych – brak przeglądów może prowadzić do nieszczelności i zagrożeń dla mieszkańców. Regularna kontrola to nie tylko wymóg prawa budowlanego, ale i podstawa bezpiecznego wynajmu lokalu.",
  },

  lodz: {
    mapBbox: "19.3397,51.6746,19.6200,51.8632",
    mapMarker: "51.7592,19.4560",
    mapCaption: "Obsługujemy wszystkie 5 dzielnic Łodzi i okolice",
    areas: [
      "Bałuty",
      "Górna",
      "Polesie",
      "Śródmieście",
      "Widzew",
      "Retkinia",
      "Zarzew",
      "Chojny",
      "Dąbrowa",
      "Koziny",
      "Stoki",
      "Marysin",
      "Radogoszcz",
    ],
    nearbyMunicipalities: [
      "Pabianice",
      "Zgierz",
      "Aleksandrów Łódzki",
      "Konstantynów Łódzki",
      "Rzgów",
    ],
    stats: [
      { value: "~350 000", label: "mieszkań i lokali w mieście" },
      { value: "5", label: "dzielnic objętych obsługą" },
      { value: "60%", label: "budynków sprzed 1990 roku" },
      { value: "kamienice fabryczne", label: "unikalna zabudowa XIX w." },
    ],
    descriptionPara1:
      "Łódź posiada jeden z największych zasobów zabytkowej zabudowy w Polsce. Charakterystyczne XIX-wieczne kamienice i dawne budynki fabryczne przekształcone w lofty to unikalne, ale i wymagające technicznie obiekty. Znaczna część łódzkiej substancji mieszkaniowej pochodzi z okresu przed 1990 rokiem.",
    descriptionPara2:
      "Starzejąca się infrastruktura techniczna w starszych budynkach Łodzi oznacza podwyższone ryzyko usterek instalacji elektrycznych i gazowych. Właściciele kamienic i zarządcy spółdzielni mieszkaniowych powinni zadbać o regularne przeglądy, aby uniknąć problemów prawnych i zapewnić bezpieczeństwo lokatorów.",
  },

  gdansk: {
    mapBbox: "18.4615,54.2867,18.7861,54.4356",
    mapMarker: "54.3520,18.6466",
    mapCaption: "Obsługujemy wszystkie dzielnice Gdańska i Trójmiasto",
    areas: [
      "Śródmieście",
      "Wrzeszcz",
      "Oliwa",
      "Żabianka",
      "Przymorze",
      "Morena",
      "Piecki-Migowo",
      "Siedlce",
      "Chełm",
      "Łostowice",
      "Osowa",
      "Kowale",
      "Brzeźno",
      "Suchanino",
      "Letnica",
    ],
    nearbyMunicipalities: [
      "Sopot",
      "Pruszcz Gdański",
      "Rumia",
      "Reda",
      "Żukowo",
    ],
    stats: [
      { value: "~200 000", label: "mieszkań i lokali w mieście" },
      { value: "35", label: "dzielnic objętych obsługą" },
      { value: "40%", label: "budynków sprzed 1985 roku" },
      { value: "odbudowa + bloki", label: "dominujący zasób mieszk." },
    ],
    descriptionPara1:
      "Gdańsk to miasto o wyjątkowej historii i zróżnicowanej zabudowie – od odbudowanego po wojnie Starego Miasta, przez modernistyczne osiedla Wrzeszcza i Oliwy, po nowe inwestycje na Morenie i w Łostowicach. Duża część zabudowy pochodzi z okresu PRL, co przekłada się na stan instalacji technicznych.",
    descriptionPara2:
      "Nadmorskie warunki klimatyczne – wysoka wilgotność i zasolenie powietrza – przyspieszają korozję instalacji gazowych i elektrycznych. To czyni regularne przeglądy techniczne w Gdańsku szczególnie istotnym elementem dbałości o bezpieczeństwo nieruchomości.",
  },

  katowice: {
    mapBbox: "18.9157,50.1780,19.0789,50.3007",
    mapMarker: "50.2649,19.0238",
    mapCaption: "Obsługujemy wszystkie 22 dzielnice Katowic i aglomerację",
    areas: [
      "Śródmieście",
      "Bogucice",
      "Dąbrówka Mała",
      "Koszutka",
      "Ligota–Panewniki",
      "Murcki",
      "Ochojec",
      "Szopienice–Burowiec",
      "Załęże",
      "Zawodzie",
      "Brynów",
      "Nikiszowiec",
      "Giszowiec",
      "Janów–Nikiszowiec",
      "Kostuchna",
    ],
    nearbyMunicipalities: [
      "Chorzów",
      "Sosnowiec",
      "Mysłowice",
      "Siemianowice Śląskie",
      "Mikołów",
    ],
    stats: [
      { value: "~160 000", label: "mieszkań i lokali w mieście" },
      { value: "22", label: "dzielnic objętych obsługą" },
      { value: "50%", label: "budynków sprzed 1985 roku" },
      { value: "familok + blok", label: "śląski typ zabudowy" },
    ],
    descriptionPara1:
      "Katowice, centrum Górnego Śląska, to miasto o intensywnej historii przemysłowej. Zabudowa mieszkaniowa obejmuje zarówno zabytkowe domy familijne z przełomu XIX i XX wieku, jak i bloki z wielkiej płyty i nowe inwestycje deweloperskie. Wiele budynków w mieście pochodzi z okresu silnego uprzemysłowienia, co wiąże się z archaiczną infrastrukturą techniczną.",
    descriptionPara2:
      "W Katowicach szczególnie ważna jest kontrola instalacji gazowych – śląska tradycja ogrzewania gazowego i duża gęstość zabudowy czynią wycieki szczególnie niebezpiecznymi. Regularne przeglądy to podstawa bezpieczeństwa zarówno w kamienicach, jak i w blokach mieszkalnych.",
  },

  szczecin: {
    mapBbox: "14.4025,53.3431,14.6987,53.5282",
    mapMarker: "53.4285,14.5528",
    mapCaption: "Obsługujemy wszystkie dzielnice Szczecina i okolice",
    areas: [
      "Śródmieście",
      "Prawobrzeże",
      "Pogodno",
      "Gumieńce",
      "Niebuszewo",
      "Żelechowa",
      "Stołczyn",
      "Golęcino",
      "Zdroje",
      "Dąbie",
      "Wielgowo",
      "Skolwin",
      "Bukowo",
      "Płonia",
    ],
    nearbyMunicipalities: [
      "Police",
      "Goleniów",
      "Gryfino",
      "Stargard",
      "Świnoujście",
    ],
    stats: [
      { value: "~200 000", label: "mieszkań i lokali w mieście" },
      { value: "5", label: "dzielnic administracyjnych" },
      { value: "45%", label: "budynków sprzed 1990 roku" },
      { value: "secesyjne kamienice", label: "charakter centrum" },
    ],
    descriptionPara1:
      "Szczecin, jedno z największych miast zachodniej Polski, charakteryzuje się piękną secesyjną zabudową w centrum oraz rozległymi osiedlami bloków na obrzeżach. Duża część zabytkowych kamienic wymaga stałej kontroli instalacji technicznych, które w wielu przypadkach nie były modernizowane od kilkudziesięciu lat.",
    descriptionPara2:
      "Bliskość morza i klimat nadmorski wpływają na szybsze starzenie się instalacji elektrycznych i gazowych w Szczecinie. Właściciele nieruchomości powinni planować przeglądy z wyprzedzeniem, aby spełniać wymogi polskiego prawa budowlanego i uniknąć kosztownych awarii.",
  },

  lublin: {
    mapBbox: "22.4285,51.1786,22.6619,51.3098",
    mapMarker: "51.2465,22.5684",
    mapCaption: "Obsługujemy wszystkie dzielnice Lublina i okolice",
    areas: [
      "Śródmieście",
      "LSM",
      "Wieniawa",
      "Czuby",
      "Kalinowszczyzna",
      "Bronowice",
      "Tatary",
      "Kośminek",
      "Hajdów",
      "Wrotków",
      "Dziesiąta",
      "Węglin",
      "Felin",
      "Za Cukrownią",
    ],
    nearbyMunicipalities: [
      "Świdnik",
      "Niemce",
      "Nałęczów",
      "Puławy",
      "Łęczna",
    ],
    stats: [
      { value: "~190 000", label: "mieszkań i lokali w mieście" },
      { value: "27", label: "dzielnic objętych obsługą" },
      { value: "42%", label: "budynków sprzed 1990 roku" },
      { value: "bloki + zabytkowy rynek", label: "LSM i Stare Miasto" },
    ],
    descriptionPara1:
      "Lublin to prężnie rozwijające się miasto akademickie z mieszaną strukturą zabudowy. Centrum stanowi zabytkowe Stare Miasto, a w dzielnicach takich jak LSM czy Czuby dominuje zabudowa z okresu PRL. Nowe osiedla na Węglinie i Felinie wyrastają przy starszej zabudowie, co tworzy duże zróżnicowanie techniki budowlanej.",
    descriptionPara2:
      "Właściciele mieszkań w lublińskich blokach i kamienicach mają ustawowy obowiązek przeprowadzania regularnych kontroli instalacji. Szczególnie w starszych budynkach warto zadbać o stan instalacji gazowej – coroczne przeglądy są wymogiem prawnym niezależnie od wieku budynku.",
  },

  bydgoszcz: {
    mapBbox: "17.9340,53.0800,18.1623,53.1926",
    mapMarker: "53.1235,18.0084",
    mapCaption: "Obsługujemy wszystkie dzielnice Bydgoszczy i okolice",
    areas: [
      "Śródmieście",
      "Fordon",
      "Brdyujście",
      "Glinki",
      "Wyżyny",
      "Wzgórze Wolności",
      "Okole",
      "Błonie",
      "Kapuściska",
      "Bartodzieje",
      "Szwederowo",
      "Leśne",
      "Osowa Góra",
      "Czyżkówko",
    ],
    nearbyMunicipalities: [
      "Solec Kujawski",
      "Osielsko",
      "Białe Błota",
      "Koronowo",
      "Dobrcz",
    ],
    stats: [
      { value: "~185 000", label: "mieszkań i lokali w mieście" },
      { value: "28", label: "dzielnic objętych obsługą" },
      { value: "44%", label: "budynków sprzed 1985 roku" },
      { value: "kamienica nadkanałowa", label: "zabytkowy typ centrum" },
    ],
    descriptionPara1:
      "Bydgoszcz to miasto z bogatą historią przemysłową i piękną zabudową nadkanałową. Centrum otaczają kamienice z przełomu XIX i XX wieku, a rozległe dzielnice jak Fordon czy Wyżyny zdominowane są przez blokowiska z okresu PRL. Znaczna część bydgoskich budynków wymaga regularnego monitorowania stanu instalacji.",
    descriptionPara2:
      "Dla właścicieli nieruchomości w Bydgoszczy szczególnym wyzwaniem jest utrzymanie instalacji elektrycznej w starszych kamienicach Śródmieścia. Aluminiowe przewody i przestarzałe tablice bezpiecznikowe to typowe problemy, które mogą stanowić zagrożenie i wymagają wymiany przez uprawnionego elektryka.",
  },

  bialystok: {
    mapBbox: "23.0691,53.0849,23.2739,53.1984",
    mapMarker: "53.1325,23.1688",
    mapCaption: "Obsługujemy wszystkie osiedla Białegostoku i okolice",
    areas: [
      "Śródmieście",
      "Bojary",
      "Zawady",
      "Starosielce",
      "Dziesięciny",
      "Nowe Miasto",
      "Wygoda",
      "Antoniuk",
      "Bagnówka",
      "Mickiewicza",
      "Słoneczny Stok",
      "Skorupy",
      "Piasta",
      "Wysoki Stoczek",
    ],
    nearbyMunicipalities: [
      "Supraśl",
      "Wasilków",
      "Łapy",
      "Choroszcz",
      "Zabłudów",
    ],
    stats: [
      { value: "~160 000", label: "mieszkań i lokali w mieście" },
      { value: "30", label: "osiedli objętych obsługą" },
      { value: "35%", label: "budynków sprzed 1985 roku" },
      { value: "wielka płyta", label: "dominujący typ zabudowy" },
    ],
    descriptionPara1:
      "Białystok, największe miasto północno-wschodniej Polski, dynamicznie rozwijał się od lat 50. ubiegłego wieku. Obok zabytkowych kamienic centrum dominują tutaj osiedla z wielkiej płyty oraz nowe budownictwo deweloperskie. Wiele budynków wciąż korzysta z oryginalnych, kilkudziesięcioletnich instalacji technicznych.",
    descriptionPara2:
      "Ze względu na surowe zimy typowe dla podlaskiego klimatu, instalacje gazowe w Białymstoku pracują intensywnie przez znaczną część roku. To przyspiesza ich zużycie i sprawia, że coroczne przeglądy nabierają szczególnego znaczenia dla bezpieczeństwa mieszkańców.",
  },

  gdynia: {
    mapBbox: "18.4427,54.4527,18.6209,54.5699",
    mapMarker: "54.5189,18.5305",
    mapCaption: "Obsługujemy wszystkie dzielnice Gdyni i okolice",
    areas: [
      "Śródmieście",
      "Chylonia",
      "Działki Leśne",
      "Cisowa",
      "Grabówek",
      "Leszczynki",
      "Mały Kack",
      "Wielki Kack",
      "Kamienna Góra",
      "Orłowo",
      "Redłowo",
      "Wzgórze Nowotki",
      "Obłuże",
      "Pogórze",
    ],
    nearbyMunicipalities: [
      "Rumia",
      "Reda",
      "Wejherowo",
      "Kartuzy",
      "Luzino",
    ],
    stats: [
      { value: "~125 000", label: "mieszkań i lokali w mieście" },
      { value: "22", label: "dzielnic objętych obsługą" },
      { value: "45%", label: "budynków sprzed 1985 roku" },
      { value: "modernizm lat 30.", label: "unikalne centrum" },
    ],
    descriptionPara1:
      "Gdynia to jedno z niewielu miast wybudowanych od podstaw w XX wieku, co nadaje jej zabudowie szczególny charakter. Modernistyczne kamienice z lat 30. w Śródmieściu, bloki z PRL na Chyloni i nowe inwestycje w Wielkim Kacku tworzą zróżnicowany zasób mieszkaniowy z różnymi potrzebami technicznymi.",
    descriptionPara2:
      "Bliskie sąsiedztwo morza i port sprawiają, że instalacje elektryczne i gazowe w Gdyni narażone są na intensywne działanie wilgoci i korozji. Regularne przeglądy są tu szczególnie istotne dla właścicieli nieruchomości, zwłaszcza tych z zabudową w pobliżu linii brzegowej.",
  },

  czestochowa: {
    mapBbox: "19.0339,50.7499,19.1921,50.8617",
    mapMarker: "50.8118,19.1203",
    mapCaption: "Obsługujemy wszystkie dzielnice Częstochowy i okolice",
    areas: [
      "Śródmieście",
      "Tysiąclecie",
      "Raków",
      "Wyczerpy",
      "Kiedrzyn",
      "Dźbów",
      "Mirów",
      "Błeszno",
      "Lisiniec",
      "Ostatni Grosz",
      "Gnaszyn",
      "Grabówka",
    ],
    nearbyMunicipalities: [
      "Myszków",
      "Kłobuck",
      "Blachownia",
      "Poczesna",
      "Konopiska",
    ],
    stats: [
      { value: "~110 000", label: "mieszkań i lokali w mieście" },
      { value: "21", label: "dzielnic objętych obsługą" },
      { value: "48%", label: "budynków sprzed 1990 roku" },
      { value: "bloki PRL", label: "Tysiąclecie i Raków" },
    ],
    descriptionPara1:
      "Częstochowa to miasto znane przede wszystkim z Jasnej Góry, ale także z dużego zasobu mieszkaniowego z okresu PRL. Osiedla takie jak Tysiąclecie czy Raków zdominowane są przez bloki, podczas gdy w centrum zachowały się starsze kamienice wymagające stałej troski technicznej.",
    descriptionPara2:
      "Właściciele mieszkań i zarządcy nieruchomości w Częstochowie mają obowiązek przeprowadzania regularnych przeglądów technicznych zgodnie z polskim Prawem budowlanym. Platforma umożliwia szybkie porównanie ofert certyfikowanych firm z terenu miasta.",
  },

  radom: {
    mapBbox: "21.0905,51.3652,21.2399,51.4508",
    mapMarker: "51.4027,21.1471",
    mapCaption: "Obsługujemy wszystkie dzielnice Radomia i okolice",
    areas: [
      "Śródmieście",
      "Gołębiów",
      "Zamłynie",
      "Borki",
      "Idalin",
      "Obozisko",
      "Południe",
      "Wośniki",
      "Planty",
      "Michałów",
      "Firlej",
      "Ustronie",
      "Halinów",
    ],
    nearbyMunicipalities: [
      "Kozienice",
      "Pionki",
      "Iłża",
      "Zwoleń",
      "Przysucha",
    ],
    stats: [
      { value: "~100 000", label: "mieszkań i lokali w mieście" },
      { value: "24", label: "dzielnic objętych obsługą" },
      { value: "46%", label: "budynków sprzed 1990 roku" },
      { value: "bloki PRL", label: "Gołębiów i Borki" },
    ],
    descriptionPara1:
      "Radom to miasto z długą historią przemysłową, gdzie obok historycznej zabudowy centrum rozciągają się duże osiedla bloków z lat 70–80. ubiegłego wieku. Znaczna część radomskiego zasobu mieszkaniowego wymaga aktualizacji instalacji technicznych.",
    descriptionPara2:
      "Zarządcy nieruchomości i właściciele mieszkań w Radomiu powinni zadbać o terminowe przeglądy – zarówno roczne kontrole instalacji gazowej, jak i pięcioletnie inspekcje elektryczne wymagane przez Prawo budowlane. Platforma ułatwia znalezienie certyfikowanych wykonawców w mieście.",
  },

  torun: {
    mapBbox: "18.5226,53.0000,18.7015,53.0893",
    mapMarker: "53.0138,18.5984",
    mapCaption: "Obsługujemy wszystkie dzielnice Torunia i okolice",
    areas: [
      "Stare Miasto",
      "Bydgoskie Przedmieście",
      "Mokre",
      "Bielawy",
      "Chełmińskie Przedmieście",
      "Jakubskie Przedmieście",
      "Rubinkowo",
      "Wrzosy",
      "Na Skarpie",
      "Grębocin",
      "Podgórz",
      "Wrzosowy Jar",
    ],
    nearbyMunicipalities: [
      "Grudziądz",
      "Chełmno",
      "Brodnica",
      "Golub-Dobrzyń",
      "Inowrocław",
    ],
    stats: [
      { value: "~110 000", label: "mieszkań i lokali w mieście" },
      { value: "22", label: "dzielnic objętych obsługą" },
      { value: "40%", label: "budynków sprzed 1985 roku" },
      { value: "gotyk + bloki PRL", label: "starówka i Rubinkowo" },
    ],
    descriptionPara1:
      "Toruń to wyjątkowe miasto z gotycką Starówką wpisaną na Listę UNESCO. Historyczne centrum kryje zabytkowe kamienice z instalacjami wymagającymi szczególnej uwagi. Poza starówką dominuje zabudowa z lat 70–80. ubiegłego wieku oraz nowe osiedla na obrzeżach.",
    descriptionPara2:
      "W przypadku zabytkowych budynków Torunia przeglądy instalacji mają dodatkowe znaczenie – uszkodzona instalacja elektryczna lub wyciek gazu mogą prowadzić do nieodwracalnych szkód w historycznej substancji budowlanej. Regularne kontrole to konieczność zarówno prawna, jak i wynikająca z odpowiedzialności za dziedzictwo.",
  },

  rzeszow: {
    mapBbox: "21.9509,49.9937,22.1097,50.0960",
    mapMarker: "50.0412,21.9991",
    mapCaption: "Obsługujemy wszystkie osiedla Rzeszowa i okolice",
    areas: [
      "Śródmieście",
      "Nowe Miasto",
      "Staroniwa",
      "Biała",
      "Zalesie",
      "Budziwój",
      "Przybyszówka",
      "Drabinianka",
      "Baranówka",
      "Pobitno",
      "Słocina",
      "Zwięczyca",
    ],
    nearbyMunicipalities: [
      "Łańcut",
      "Głogów Małopolski",
      "Tyczyn",
      "Boguchwała",
      "Świlcza",
    ],
    stats: [
      { value: "~110 000", label: "mieszkań i lokali w mieście" },
      { value: "29", label: "osiedli objętych obsługą" },
      { value: "30%", label: "budynków sprzed 1985 roku" },
      { value: "nowe budownictwo", label: "dynamiczny rozwój miasta" },
    ],
    descriptionPara1:
      "Rzeszów, dynamicznie rozwijające się miasto Podkarpacia, jest jednym z najszybciej rosnących ośrodków miejskich w Polsce. Obok starszej zabudowy centrum intensywnie powstają nowe osiedla, co przekłada się na duże zróżnicowanie wieku i stanu instalacji technicznych w mieście.",
    descriptionPara2:
      "Nawet w nowym budownictwie warto przeprowadzać regularne przeglądy – usterki pojawiają się niezależnie od wieku budynku. W starszych częściach Rzeszowa konieczność kontroli wynika natomiast często z faktycznego zużycia instalacji elektrycznych i gazowych.",
  },

  kielce: {
    mapBbox: "20.5682,50.8215,20.7120,50.9172",
    mapMarker: "50.8661,20.6286",
    mapCaption: "Obsługujemy wszystkie dzielnice Kielc i okolice",
    areas: [
      "Śródmieście",
      "KSM",
      "Na Stoku",
      "Czarnów",
      "Słoneczne Wzgórze",
      "Bocianek",
      "Baranówek",
      "Herby",
      "Uroczysko",
      "Pakosz",
      "Kawetczyzna",
      "Zagórze",
    ],
    nearbyMunicipalities: [
      "Morawica",
      "Masłów",
      "Piekoszów",
      "Daleszyce",
      "Chmielnik",
    ],
    stats: [
      { value: "~100 000", label: "mieszkań i lokali w mieście" },
      { value: "27", label: "dzielnic objętych obsługą" },
      { value: "40%", label: "budynków sprzed 1990 roku" },
      { value: "bloki + kamienice", label: "KSM i Śródmieście" },
    ],
    descriptionPara1:
      "Kielce to regionalne centrum Świętokrzyskiego z mieszaną strukturą zabudowy. Śródmieście oferuje zabytkowe kamienice, a rozległe osiedla jak KSM czy Na Stoku to typowa zabudowa wielorodzinna z lat PRL. Duża część zasobu mieszkaniowego wymaga regularnej kontroli technicznej.",
    descriptionPara2:
      "Właściciele mieszkań w kieleckich blokach i kamienicach mają ustawowy obowiązek przeprowadzania regularnych przeglądów instalacji. Wiele budynków w mieście posiada przestarzałe instalacje elektryczne lub gazowe wymagające modernizacji lub co najmniej regularnej kontroli.",
  },

  gliwice: {
    mapBbox: "18.6072,50.2519,18.7378,50.3282",
    mapMarker: "50.2945,18.6714",
    mapCaption: "Obsługujemy wszystkie dzielnice Gliwic i aglomerację",
    areas: [
      "Śródmieście",
      "Trynek",
      "Zatorze",
      "Szobiszowice",
      "Sośnica",
      "Ostropa",
      "Stare Gliwice",
      "Żerniki",
      "Bojków",
      "Ligota Zabrska",
      "Czechowice",
      "Sikornik",
      "Łabędy",
    ],
    nearbyMunicipalities: [
      "Knurów",
      "Pyskowice",
      "Bytom",
      "Ruda Śląska",
      "Zabrze",
    ],
    stats: [
      { value: "~95 000", label: "mieszkań i lokali w mieście" },
      { value: "24", label: "dzielnic objętych obsługą" },
      { value: "50%", label: "budynków sprzed 1990 roku" },
      { value: "kamienica + familok", label: "historyczne centrum i robotnicze" },
    ],
    descriptionPara1:
      "Gliwice, ważne centrum aglomeracji górnośląskiej, łączą przemysłową historię z nowoczesnym rozwojem. Zabudowa mieszkaniowa to mix historycznych kamienic śródmiejskich, familoków, bloków z wielkiej płyty i nowych inwestycji. Duża część budynków pochodzi z okresu intensywnego uprzemysłowienia regionu.",
    descriptionPara2:
      "Sąsiedztwo Katowic i gęsta tkanka przemysłowa w przeszłości sprawiły, że wiele budynków w Gliwicach ma przestarzałą infrastrukturę techniczną. Regularne przeglądy instalacji elektrycznych i gazowych są tu szczególnie istotne dla bezpieczeństwa mieszkańców.",
  },

  zabrze: {
    mapBbox: "18.7078,50.2629,18.8197,50.3429",
    mapMarker: "50.3249,18.7857",
    mapCaption: "Obsługujemy wszystkie dzielnice Zabrza i aglomerację",
    areas: [
      "Śródmieście",
      "Biskupice",
      "Centrum",
      "Guido",
      "Grzybowice",
      "Helenka",
      "Kończyce",
      "Maciejów",
      "Makoszowy",
      "Mikulczyce",
      "Pawłów",
      "Rokitnica",
      "Zaborze",
    ],
    nearbyMunicipalities: [
      "Gliwice",
      "Bytom",
      "Ruda Śląska",
      "Świętochłowice",
      "Piekary Śląskie",
    ],
    stats: [
      { value: "~85 000", label: "mieszkań i lokali w mieście" },
      { value: "22", label: "dzielnic objętych obsługą" },
      { value: "55%", label: "budynków sprzed 1985 roku" },
      { value: "familoki górnicze", label: "charakterystyczny typ budynków" },
    ],
    descriptionPara1:
      "Zabrze, miasto o bogatej tradycji górniczej, posiada zabudowę mieszkaniową o bardzo zróżnicowanym charakterze. Historyczne familoki i domy robotnicze sąsiadują z blokowiskami oraz nowszą zabudową. Starsza substancja techniczna w wielu budynkach wymaga regularnych kontroli i modernizacji.",
    descriptionPara2:
      "Dla właścicieli nieruchomości w Zabrzu szczególnie ważna jest kontrola instalacji gazowych w budynkach wielorodzinnych – tradycja ogrzewania gazowego i duża gęstość zabudowy czynią wycieki szczególnie niebezpiecznymi. Regularne przeglądy to podstawowe narzędzie zapobiegania awariom.",
  },

  olsztyn: {
    mapBbox: "20.4039,53.7319,20.5718,53.8230",
    mapMarker: "53.7784,20.4801",
    mapCaption: "Obsługujemy wszystkie osiedla Olsztyna i okolice",
    areas: [
      "Śródmieście",
      "Zatorze",
      "Pojezierze",
      "Podleśna",
      "Jaroty",
      "Kortowo",
      "Likusy",
      "Dajtki",
      "Gutkowo",
      "Pieczewo",
      "Nagórki",
      "Komorowo",
    ],
    nearbyMunicipalities: [
      "Dywity",
      "Stawiguda",
      "Barczewo",
      "Dobre Miasto",
      "Purda",
    ],
    stats: [
      { value: "~95 000", label: "mieszkań i lokali w mieście" },
      { value: "23", label: "osiedli objętych obsługą" },
      { value: "35%", label: "budynków sprzed 1990 roku" },
      { value: "bloki + nowe osiedla", label: "miasto przy jeziorach" },
    ],
    descriptionPara1:
      "Olsztyn, stolica Warmii i Mazur, jest jednym z najbardziej zielonych miast Polski. Zabudowa mieszkaniowa łączy zabytkowe centrum ze Starówką, blokowiskami z lat PRL oraz nowymi osiedlami na obrzeżach nad jeziorami.",
    descriptionPara2:
      "Mroźne zimy charakterystyczne dla klimatu warmińskiego intensywnie obciążają instalacje grzewcze i gazowe. Właściciele nieruchomości w Olsztynie powinni szczególnie dbać o coroczne przeglądy instalacji gazowej, aby zapewnić bezpieczeństwo w sezonie grzewczym.",
  },

  "bielsko-biala": {
    mapBbox: "18.9613,49.8000,19.1241,49.8881",
    mapMarker: "49.8224,19.0444",
    mapCaption: "Obsługujemy wszystkie dzielnice Bielska-Białej i okolice",
    areas: [
      "Śródmieście",
      "Wapienica",
      "Kamienica",
      "Aleksandrowice",
      "Biała",
      "Hałcnów",
      "Komorowice",
      "Lipnik",
      "Mikuszowice",
      "Olszówka",
      "Stare Bielsko",
      "Złote Łany",
    ],
    nearbyMunicipalities: [
      "Czechowice-Dziedzice",
      "Szczyrk",
      "Skoczów",
      "Kozy",
      "Andrychów",
    ],
    stats: [
      { value: "~90 000", label: "mieszkań i lokali w mieście" },
      { value: "30", label: "dzielnic objętych obsługą" },
      { value: "42%", label: "budynków sprzed 1990 roku" },
      { value: "kamienice XIX w.", label: "austro-węgierskie centrum" },
    ],
    descriptionPara1:
      "Bielsko-Biała, miasto u podnóża Beskidów, łączy dwie historycznie odrębne miejscowości: Bielsko (dawniej pruskie) i Białą (dawniej austro-węgierską). To sprawia, że zabudowa centrum ma szczególny charakter architektoniczny, a kamienice z przełomu XIX i XX wieku wymagają stałej kontroli stanu technicznego instalacji.",
    descriptionPara2:
      "Górskie położenie i zmienne warunki klimatyczne przyspieszają zużycie instalacji technicznych w Bielsku-Białej. Regularne przeglądy instalacji elektrycznej, gazowej i czujników dymu są tu szczególnie ważne, zwłaszcza w starszych budynkach centrum.",
  },

  rybnik: {
    mapBbox: "18.4944,50.0637,18.6121,50.1371",
    mapMarker: "50.0923,18.5420",
    mapCaption: "Obsługujemy wszystkie dzielnice Rybnika i aglomerację",
    areas: [
      "Śródmieście",
      "Boguszowice",
      "Chwałęcice",
      "Chwałowice",
      "Golejów",
      "Grabownia",
      "Kłokocin",
      "Ligota",
      "Niedobczyce",
      "Nowiny",
      "Ochojec",
      "Paruszowiec",
      "Popielów",
    ],
    nearbyMunicipalities: [
      "Jastrzębie-Zdrój",
      "Żory",
      "Knurów",
      "Wodzisław Śląski",
      "Pszów",
    ],
    stats: [
      { value: "~75 000", label: "mieszkań i lokali w mieście" },
      { value: "27", label: "dzielnic objętych obsługą" },
      { value: "45%", label: "budynków sprzed 1990 roku" },
      { value: "familoki + bloki", label: "aglomeracja rybnicka" },
    ],
    descriptionPara1:
      "Rybnik to ważne centrum aglomeracji rybnickiej na południu Górnego Śląska. Zabudowa mieszkaniowa obejmuje historyczne domy familijne, bloki z lat PRL oraz nowe osiedla. Wiele budynków w mieście ma przestarzałe instalacje techniczne wymagające regularnej kontroli.",
    descriptionPara2:
      "Branża górnicza przez dziesięciolecia dominowała w Rybniku, a wiele starszych budynków robotniczych ma archaiczne instalacje elektryczne i gazowe. Regularne przeglądy to nie tylko wymóg prawny, ale i podstawa bezpiecznego użytkowania takich nieruchomości.",
  },

  tychy: {
    mapBbox: "18.9459,50.0875,19.0557,50.1591",
    mapMarker: "50.1262,18.9963",
    mapCaption: "Obsługujemy wszystkie dzielnice Tychów i aglomerację",
    areas: [
      "Centrum",
      "Osiedle A",
      "Osiedle B",
      "Osiedle C",
      "Osiedle D",
      "Osiedle E",
      "Osiedle F",
      "Osiedle G",
      "Czułów",
      "Paprocany",
      "Wartogłowiec",
      "Żwaków",
    ],
    nearbyMunicipalities: [
      "Mikołów",
      "Bieruń",
      "Lędziny",
      "Orzesze",
      "Łaziska Górne",
    ],
    stats: [
      { value: "~65 000", label: "mieszkań i lokali w mieście" },
      { value: "14", label: "dzielnic objętych obsługą" },
      { value: "60%", label: "budynków sprzed 1990 roku" },
      { value: "bloki liter (A–G)", label: "unikalne miasto-ogród" },
    ],
    descriptionPara1:
      "Tychy to miasto o wyjątkowej historii – zbudowane praktycznie od podstaw w latach 50. ubiegłego wieku jako tzw. miasto-ogród. Zabudowa jest w dużej mierze jednorodna – dominują osiedla bloków oznaczonych literami, co tworzy specyficzną strukturę urbanistyczną. Wiele z tych budynków dobiega lub przekroczyło 60 lat.",
    descriptionPara2:
      "Wiek zabudowy w Tychach oznacza, że instalacje techniczne w wielu budynkach wymagają modernizacji lub co najmniej regularnych kontroli. Właściciele mieszkań i zarządcy spółdzielni mieszkaniowych mają ustawowy obowiązek przeprowadzania przeglądów zgodnie z Prawem budowlanym.",
  },

  "dabrowa-gornicza": {
    mapBbox: "19.0989,50.2896,19.2682,50.3892",
    mapMarker: "50.3244,19.1840",
    mapCaption: "Obsługujemy wszystkie dzielnice Dąbrowy Górniczej i aglomerację",
    areas: [
      "Śródmieście",
      "Ząbkowice",
      "Łękinia",
      "Gołonóg",
      "Huta Bankowa",
      "Strzemieszyce",
      "Bugaj",
      "Łazy",
      "Antoniów",
      "Trzebiesławice",
      "Tucznawa",
      "Sikorka",
    ],
    nearbyMunicipalities: [
      "Będzin",
      "Sławków",
      "Czeladź",
      "Sosnowiec",
      "Bobrowniki",
    ],
    stats: [
      { value: "~80 000", label: "mieszkań i lokali w mieście" },
      { value: "15", label: "dzielnic objętych obsługą" },
      { value: "52%", label: "budynków sprzed 1990 roku" },
      { value: "bloki + domy robotnicze", label: "zabudowa aglomeracji" },
    ],
    descriptionPara1:
      "Dąbrowa Górnicza to rozległe miasto aglomeracji górnośląskiej o silnych tradycjach przemysłowych. Zabudowa jest zróżnicowana – centrum otaczają kamienice i starsze budynki, a dzielnice jak Ząbkowice czy Łękinia zdominowane są przez zabudowę wielorodzinną z okresu PRL.",
    descriptionPara2:
      "Dla właścicieli nieruchomości w Dąbrowie Górniczej regularne przeglądy instalacji mają szczególne znaczenie w kontekście ubezpieczenia nieruchomości – ubezpieczyciele coraz częściej wymagają aktualnych protokołów przeglądowych jako warunek wypłaty odszkodowania.",
  },

  plock: {
    mapBbox: "19.6510,52.5102,19.8108,52.5911",
    mapMarker: "52.5463,19.7065",
    mapCaption: "Obsługujemy wszystkie dzielnice Płocka i okolice",
    areas: [
      "Śródmieście",
      "Radziwie",
      "Dworzec",
      "Góry",
      "Kostrogaj",
      "Nowe Miasto",
      "Podolszyce",
      "Pradolina Wisły",
      "Skarpa",
      "Stare Miasto",
      "Zielony Jar",
      "Łukasiewicza",
    ],
    nearbyMunicipalities: [
      "Bielsk",
      "Stara Biała",
      "Drobin",
      "Bodzanów",
      "Nowy Duninów",
    ],
    stats: [
      { value: "~75 000", label: "mieszkań i lokali w mieście" },
      { value: "18", label: "dzielnic objętych obsługą" },
      { value: "48%", label: "budynków sprzed 1990 roku" },
      { value: "bloki + kamienice", label: "Wzgórze Tumskie i osiedla" },
    ],
    descriptionPara1:
      "Płock, miasto nad Wisłą, to jeden z ważniejszych ośrodków przemysłowych w regionie mazowieckim. Zabudowa mieszkaniowa obejmuje zabytkowe centrum ze Wzgórzem Tumskim, rozległe osiedla blokowe oraz nowe inwestycje deweloperskie. Wiele budynków pochodzi z okresu intensywnego rozwoju przemysłowego lat 60–80.",
    descriptionPara2:
      "Właściciele mieszkań i zarządcy wspólnot mieszkaniowych w Płocku mają obowiązek przeprowadzania regularnych przeglądów instalacji. Platforma umożliwia szybkie porównanie ofert certyfikowanych firm z terenu miasta i okolic.",
  },

  opole: {
    mapBbox: "17.8477,50.6278,17.9951,50.7161",
    mapMarker: "50.6751,17.9213",
    mapCaption: "Obsługujemy wszystkie dzielnice Opola i okolice",
    areas: [
      "Śródmieście",
      "Zaodrze",
      "Chabrów",
      "Bierkowice",
      "Groszowice",
      "Grudzice",
      "Półwieś",
      "Gosławice",
      "Szczepanowice",
      "Malinka",
      "Nowa Wieś Królewska",
      "Zakrzów",
    ],
    nearbyMunicipalities: [
      "Prószków",
      "Dąbrowa",
      "Komprachcice",
      "Tarnów Opolski",
      "Turawa",
    ],
    stats: [
      { value: "~65 000", label: "mieszkań i lokali w mieście" },
      { value: "27", label: "dzielnic objętych obsługą" },
      { value: "40%", label: "budynków sprzed 1990 roku" },
      { value: "kamienice + bloki", label: "centrum Wyspy Pasieka" },
    ],
    descriptionPara1:
      "Opole, stolica województwa opolskiego, to miasto o bogatej historii i pięknym centrum z Wyspą Pasieka. Zabudowa mieszkaniowa łączy historyczne kamienice ze Śródmieścia z blokowiskami na obrzeżach i nowymi osiedlami willowymi. Różnorodność zabudowy oznacza zróżnicowane potrzeby w zakresie przeglądów technicznych.",
    descriptionPara2:
      "Jako miasto o stosunkowo dużym udziale zabytkowej zabudowy, Opole wymaga szczególnej uwagi właścicieli nieruchomości w kwestii stanu instalacji technicznych. Regularne przeglądy to nie tylko wymóg prawny, ale i sposób na ochronę wartości historycznej substancji budowlanej.",
  },

  elblag: {
    mapBbox: "19.3741,54.1318,19.5220,54.1966",
    mapMarker: "54.1559,19.4044",
    mapCaption: "Obsługujemy wszystkie dzielnice Elbląga i okolice",
    areas: [
      "Śródmieście",
      "Zatorze",
      "Wyspa Spichrzów",
      "Bażantarnia",
      "Zawada",
      "Modrzewina",
      "Próchnik",
      "Kamionka",
      "Portowa",
      "Skrzetusko",
      "Dębica",
      "Kępa",
    ],
    nearbyMunicipalities: [
      "Malbork",
      "Braniewo",
      "Pasłęk",
      "Nowy Dwór Gdański",
      "Tolkmicko",
    ],
    stats: [
      { value: "~65 000", label: "mieszkań i lokali w mieście" },
      { value: "20", label: "dzielnic objętych obsługą" },
      { value: "45%", label: "budynków sprzed 1990 roku" },
      { value: "bloki powojenne", label: "odbudowa po 1945 r." },
    ],
    descriptionPara1:
      "Elbląg to miasto z długą historią, które zostało niemal doszczętnie zniszczone w 1945 roku i odbudowane w nowym kształcie. Centrum charakteryzuje się odbudowaną starówką, podczas gdy dzielnice takie jak Zatorze to zabudowa wielorodzinna z okresu PRL. Wiele budynków dobiegło lub przekroczyło 50–60 lat.",
    descriptionPara2:
      "Bliskość Zalewu Wiślanego i specyficzny mikroklimat elbląski – wysoka wilgotność powietrza – przyspieszają korozję instalacji technicznych. Właściciele nieruchomości powinni szczególnie dbać o regularną kontrolę instalacji elektrycznej i gazowej.",
  },

  walbrzych: {
    mapBbox: "16.2022,50.7222,16.3524,50.8061",
    mapMarker: "50.7729,16.2844",
    mapCaption: "Obsługujemy wszystkie dzielnice Wałbrzycha i okolice",
    areas: [
      "Śródmieście",
      "Stary Zdrój",
      "Biały Kamień",
      "Sobięcin",
      "Podgórze",
      "Nowe Miasto",
      "Podzamcze",
      "Rusinowa",
      "Szczawienko",
      "Boguszów",
      "Piaskowa Góra",
      "Książ",
    ],
    nearbyMunicipalities: [
      "Świdnica",
      "Dzierżoniów",
      "Boguszów-Gorce",
      "Jedlina-Zdrój",
      "Szczawno-Zdrój",
    ],
    stats: [
      { value: "~60 000", label: "mieszkań i lokali w mieście" },
      { value: "19", label: "dzielnic objętych obsługą" },
      { value: "55%", label: "budynków sprzed 1985 roku" },
      { value: "kamienica + blok górn.", label: "górnicza spuścizna" },
    ],
    descriptionPara1:
      "Wałbrzych, dawne centrum górnictwa węglowego w Sudetach, przeszedł głęboką transformację po zamknięciu kopalń. Zabudowa mieszkaniowa to w dużej mierze budynki z okresu przemysłowego – wiele z nich pochodzi z przełomu XIX i XX wieku lub z okresu PRL. Starzejąca się substancja budowlana wymaga regularnej kontroli instalacji technicznych.",
    descriptionPara2:
      "W Wałbrzychu szczególnie ważne są przeglądy instalacji elektrycznej w starszych budynkach – wiele z nich wciąż posiada archaiczną instalację aluminiową lub papierową, która stanowi zagrożenie pożarowe. Regularne kontrole to podstawowy środek bezpieczeństwa.",
  },

  "zielona-gora": {
    mapBbox: "15.4599,51.9011,15.5969,51.9770",
    mapMarker: "51.9355,15.5062",
    mapCaption: "Obsługujemy wszystkie osiedla Zielonej Góry i okolice",
    areas: [
      "Śródmieście",
      "Osiedle Zacisze",
      "Osiedle Piastowskie",
      "Osiedle Łużyckie",
      "Osiedle Słoneczne",
      "Zawada",
      "Kiełpin",
      "Drzonków",
      "Łężyca",
      "Sucha",
      "Przylep",
      "Racula",
    ],
    nearbyMunicipalities: [
      "Nowa Sól",
      "Sulechów",
      "Świebodzin",
      "Żagań",
      "Krosno Odrzańskie",
    ],
    stats: [
      { value: "~75 000", label: "mieszkań i lokali w mieście" },
      { value: "22", label: "osiedli objętych obsługą" },
      { value: "38%", label: "budynków sprzed 1990 roku" },
      { value: "kamienica + blok PRL", label: "centrum i nowe osiedla" },
    ],
    descriptionPara1:
      "Zielona Góra to dynamicznie rozwijająca się stolica województwa lubuskiego, znana z Winobrania. Zabudowa mieszkaniowa łączy centrum z kamienicami z przełomu XIX/XX wieku z nowymi osiedlami na obrzeżach. Wiele budynków pochodzi z lat 60–80. ubiegłego wieku.",
    descriptionPara2:
      "Właściciele nieruchomości w Zielonej Górze mają ustawowy obowiązek przeprowadzania regularnych przeglądów instalacji elektrycznych i gazowych. Platforma umożliwia porównanie ofert certyfikowanych firm działających na terenie miasta i jego bezpośrednich okolic.",
  },

  koszalin: {
    mapBbox: "16.1225,54.1710,16.2387,54.2285",
    mapMarker: "54.1943,16.1714",
    mapCaption: "Obsługujemy wszystkie dzielnice Koszalina i okolice",
    areas: [
      "Śródmieście",
      "Rokosowo",
      "Wspólny Dom",
      "Osiedle Północ",
      "Podgrodzie",
      "Morskie",
      "Jamno",
      "Lubiatowo",
      "Kretomino",
      "Raduszka",
      "Stare Miasto",
    ],
    nearbyMunicipalities: [
      "Kołobrzeg",
      "Białogard",
      "Szczecinek",
      "Sławno",
      "Mielno",
    ],
    stats: [
      { value: "~55 000", label: "mieszkań i lokali w mieście" },
      { value: "10", label: "dzielnic objętych obsługą" },
      { value: "42%", label: "budynków sprzed 1990 roku" },
      { value: "bloki + nowe os.", label: "Środkowe Wybrzeże" },
    ],
    descriptionPara1:
      "Koszalin to największe miasto Środkowego Wybrzeża, centrum regionalne Pomorza Środkowego. Zabudowa mieszkaniowa to przede wszystkim bloki z okresu PRL i nowe osiedla – centrum miasta wciąż dysponuje kamienicami wymagającymi regularnych kontroli technicznych.",
    descriptionPara2:
      "Nadmorskie położenie i wilgotny klimat morski przyspieszają korozję instalacji technicznych w budynkach Koszalina. Właściciele nieruchomości powinni planować regularne przeglądy instalacji elektrycznej i gazowej, aby uniknąć kosztownych awarii i problemów ubezpieczeniowych.",
  },
};

export function getCityPageData(slug: string): CityPageData {
  return CITY_PAGE_DATA[slug] ?? DEFAULT_DATA;
}
